import MenuHeader from "../../common/MenuHeader"
import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const Emitter = (props: Props) => {
  return (
    <SetUpLayout
      title='Emitter'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }}
      />}
    >
      <LayoutMain title="Data 7 of 9" subtitle="Emitter" />
    </SetUpLayout>
  )
}

export default Emitter